<template>
  <v-card flat>
    <v-container class="mx-0" style="max-width: 100%;">
      <v-layout row justify-space-between>
        <v-flex xs2>
          <div class="subheading" style="border-right: 1px solid lightgrey">
            <v-icon x-large color="green darken-2">description</v-icon>
            <span class="subheading">论文</span>
          </div>
        </v-flex>
        <v-flex xs10 class="text-xs-center">
          <table style="width: 100%">
            <tbody>
            <tr>
              <td v-for="it in items" :key="it.dbid" style="width: 12.5%">{{it.name}}</td>
            </tr>
            <tr>
              <td v-for="it in items" :key="it.dbid">{{it.count || 0}}</td>
            </tr>
            </tbody>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
  const uri = '/api/papr/report/count/by/level-and-index';

  export default {
    data() {
      return {
        loading: false,

        items: []
      }
    },
    created() {
      this.get()
    },

    methods: {
      /**
       * **************************************************************
       * 异步数据请求
       */
      get() {
        const vm = this;
        this.loading = true;
        const param = {};
        this.axios.get(uri, param)
          .then(rsp => {
            // 填充对话框
            vm.items = rsp.data;
            vm.loading = false;
          });
      }

    }
  }
</script>
<style scoped>

</style>
